module.exports = __webpack_public_path__ + "img/copy-icon.2d945860.svg";